import { XCircle } from "lucide-react";

interface GenerationErrorStateProps {
  title: string;
  message: string;
  actionLabel: string;
  onAction: () => void;
}

export function GenerationErrorState({
  title,
  message,
  actionLabel,
  onAction,
}: GenerationErrorStateProps) {
  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6">
      <div className="text-center">
        <XCircle className="size-16 text-red-400 mx-auto mb-4" />
        <h1 className="text-xl sm:text-2xl font-bold text-white mb-2">{title}</h1>
        <p className="text-[#888] mb-6">{message}</p>
        <button
          onClick={onAction}
          className="px-6 py-3 rounded-xl bg-white/[0.1] text-white hover:bg-white/[0.15] transition-colors"
        >
          {actionLabel}
        </button>
      </div>
    </div>
  );
}
